import { buildPlanCanvas, makeFlowBlockInput } from './utils';

export function changeVersion(state, action) {
  const newStep = action.version;
  // handle new inputs
  let inputs = state.inputs || [];
  const editingBlockId = state.savedEditingBlock.id;
  const unrelatedMappings = inputs.filter(
    i => i.flowBlock.id !== editingBlockId,
  );
  const currentMappingMap = inputs
    .filter(i => i.flowBlock.id === editingBlockId)
    .reduce((acc, i) => {
      acc[i.scriptStepInput.name] = i;
      return acc;
    }, {});

  const newInputs = newStep.inputs.data.map(i => {
    const newInput = makeFlowBlockInput(editingBlockId, i);
    const value = currentMappingMap[i.name]
      ? currentMappingMap[i.name].value
      : null;
    return { ...newInput, value };
  });

  inputs = [...unrelatedMappings, ...newInputs];

  const changeBlockStepId = block =>
    block.id !== editingBlockId
      ? block
      : { ...block, step: { ...block.step, id: newStep.id } };

  let updatedBlocks = state.planCanvas.blocks.map(changeBlockStepId);

  // handle new endpoint
  let { endpoints } = state;
  if (newStep.endpointType !== state.savedFlowBlockStep.endpointType) {
    const clearEndpoint = block =>
      block.id !== editingBlockId ? block : { ...block, endpoint: null };
    updatedBlocks = updatedBlocks.map(clearEndpoint);
    endpoints = state.endpoints.filter(e => e.flowBlockId !== editingBlockId);
  }

  // handle runLocation
  updatedBlocks = updatedBlocks.map(block =>
    block.id !== editingBlockId
      ? block
      : { ...block, environment: newStep.allowedEnvironment },
  );
  const planCanvas = buildPlanCanvas({
    ...state,
    inputs,
    blocks: updatedBlocks,
    edges: state.planCanvas.edges,
  });

  return {
    ...state,
    inputs,
    planCanvas,
    endpoints,
    blocks: updatedBlocks,
  };
}
